export default {
  SAVE_TRANCHES: (state, data) => {
    if (data.account && data.account.tranches) {
      state.tranches = data.account.tranches
    } else if (data.tranches) {
      state.tranches = data.tranches.page_data
      state.tranchesPagination = data.tranches.pagination
    }
    state.pending = false
  },
  PENDING: (state, data) => {
    state.pending = data
  },
  SAVE_SEARCH_TRANCHES: (state, data) => {
    state.searchTranches = data.tranches.page_data
    state.searchDataExist = data.tranches.page_data.length > 0
    state.searchPagination = data.tranches.pagination
    state.pending = false
  },
  CLEAR_SEARCH: (state, data) => {
    state.searchTranches = []
    state.searchDataExist = null
    state.searchPagination = false
  },
  SAVE_STATUSES: (state, data) => {
    state.statuses = data.tranches.statuses
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/tranches/mutations.js